/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedFeeds.defs.js'
export * as $defs from './getSuggestedFeeds.defs.js'
